import { useQuery, useMutation } from "@tanstack/react-query";
import {
  fetch2,
  fetch3,
  fetch5,
  fetch6,
  fetch8,
} from "../commonApis/commonApis";
import { useDispatch } from "react-redux";
import {
  addOutSource,
  setOutSourceList,
} from "../features/outSource/outSourceSlice";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  error?: any;
}

type OutSourceStatus = {
  id: string;
  status: boolean;
};

export const useOutSourceCreateMutation = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch2(`${url}/api/outSources/`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || res?.error || "Something went wrong";
      }

      return res;
    },
    onSuccess: (data: any) => {
      console.log("✅ OutSource Created successfully:", data);
      // dispatch(addOutSource(data));
    },
    onError: (error: any) => {
      console.error("❌ OutSource create request failed:", error.message);
      return error?.message;
    },
  });
};

export const useFetchOutSourcesData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["outSourcesData", "list", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/outSources?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }
      dispatch(setOutSourceList(res.data));

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useUpdateOutSourceStatus = () => {
  return useMutation({
    mutationFn: async (payload: OutSourceStatus) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/outSources/status/${payload.id}`,
        "PATCH",
        { status: payload.status }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
  });
};

export const useFetchOutSourcesDataDetails = (id: any) => {
  return useQuery({
    queryKey: ["outSourcesData", "details", id],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/outSources/${id}`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useUpdateOutSourceData = (id: any) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch6(
        `${url}/api/outSources/${id}`,
        payload
      );

      if (!res.success) {
        throw res.message || res?.error || "Failed to update vehicle status";
      }

      return res;
    },
    onSuccess: (data: any) => {
      console.log("✅ OutSource Updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ OutSource updated request failed:", error.message);
      return error;
    },
  });
};

export const useOutSourceBulkDocMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch8(
        `${url}/api/bulk/bulk-outsource`,
        "POST",
        payload
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res;
    },
    onSuccess: (res: any) => {
      console.log("Our Source bulk Created successfully:", res);
      return res;
    },
    onError: (error: any) => {
      console.error("Our Source bulk create request failed:", error.message);
    },
  });
};

export const useFetchOutSourceTemplate = () => {
  return useQuery({
    queryKey: ["templates"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/templates/out-source`, "get");
      if (!res || !res.data) return res.message;
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchOutSourceDriversData = (id: string, page: number, limit: number, searchFor: string) => {
  return useQuery({
    queryKey: ["outSourceDriversData", id, page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/outSources/${id}/drivers?page=${page}&limit=${limit}&searchFor=${searchFor}`,
        "get"
      );
      if (!res || !res.data) {
        return res.message;
      }
      return res.data; 
    },
    staleTime: 1000 * 60 * 5,
  });
};
